import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { BusinessTripsRouter } from '../../../business-trips/types';
import { modules } from '../../modules';

@injectable()
export class BusinessTripsRouterService implements BusinessTripsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(id: string) {
    this.history.push(`/${this.role.get()}/${modules.events.basename}/${id}`);
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${this.role.get()}/${modules.business_trips.basename}`,
      );
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.business_trips.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreate(query: string) {
    this.history.push({
      pathname: `/${this.role.get()}/${modules.events.basename}/create`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreateBatch({
    companyId,
    eventTypeId,
    employeeId,
    parentEventId,
  }: {
    companyId: string;
    eventTypeId: string;
    employeeId?: string;
    parentEventId?: string;
  }) {
    let searchString = `?companyId=${companyId}&eventTypeId=${eventTypeId}`;

    if (employeeId) {
      searchString += `&employeeId=${employeeId}`;
    }

    if (parentEventId) {
      searchString += `&parentEventId=${parentEventId}`;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.events.basename}/create-batch`,
      search: searchString,
    });
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }
}
